import { createSlice } from "@reduxjs/toolkit";

const userSlice = createSlice({
  name: "user",
  initialState: {
    url: "https://platform-api.settlemyloan.in",
    step: "",
    count: 0,
    user: null,
    welcomeDone: false,
    plan: {
      months: "",
      emi: "",
      total: "",
    },
  },
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload;
    },
    setStep: (state, action) => {
      state.step = action.payload;
    },
    setPlan: (state, action) => {
      state.plan.months = action.payload.months;
      state.plan.emi = action.payload.emi;
      state.plan.total = action.payload.total;
    },
    setWelcomeDone: (state, action) => {
      state.welcomeDone = action.payload;
    },
    setCount: (state, action) => {
      state.count = action.payload;
    },
  },
});

export const { setUser, setStep, setPlan, setWelcomeDone, setCount } =
  userSlice.actions;
export default userSlice.reducer;
